// extracted by mini-css-extract-plugin
export default {"search":"Search_search__9+nEv","close":"Search_close__BiMcD"};